export const DEFAULT_COLORS = {
  primary_color: "#F2E94E",
  secondary_color: "#000000",
  page_background_color: "#FFFFFF",
  button_text_color: "#000000",
};

export const DEFAULT_TEMPLATE_COLORS = {
  "template-primary-color": "#F2E94E",
  "template-secondary-color": "#000000",
  "template-page-background": "#FFFFFF",
  "template-primary-button-text-color": "#000000",
};

export const TEMPLATE_COLOR_KEY_PREFIX = "template-";

export const COLOR_PICKER_DEBOUNCE_MS = 500;

export const MAPPED_COLOR_KEYS = Object.keys(DEFAULT_COLORS);

export const TEMPLATE_COLOR_KEYS = Object.keys(DEFAULT_TEMPLATE_COLORS);
